import React, { useContext } from 'react';
import MainChartContainer from './MainChartContainer'
import IntroContainer from './IntroContainer'
import styled, { css } from 'styled-components'
import { ChartContext } from '../context/ChartContext'
import FixedControl from './FixedControl';
import Credit from './Credit';

const CoverDiv = styled.div`

  ${ props => props.started ? css`
    height: auto;
  `  : css`
    height: 100vh;
  `} 

  width: 100vw;
  background: #fff;
`

const MainDiv = styled.div`

  display: grid;
  grid-template-columns: minmax(5rem, 1fr) minmax(800px, 1440px) minmax(5rem, 1fr);


  ${ props => props.started ? css`
    grid-template-rows: minmax(5rem, 1fr) 650px 5rem auto 8rem;
    grid-template-areas:  ". . ."
                        ". intro ."
                        ". . ."
                        ". content ."
                        ". credit .";
  `  : css`
    grid-template-rows: minmax(5rem, 1fr) 650px 0rem minmax(5rem, 1fr);
    grid-template-areas:  ". . ."
                        ". intro ."
                        ". . ."
                        ". . .";
  `} 
  


  height: 100%;
  width: 100%;
`

const ChartLayout = () => {
  
    const { path } = useContext(ChartContext)
    const started = path !==  'both'
    // ADD TOOLTIP TO SVG MAP
    // ADD DIMENSION UPDATE TO SVG MAP
    // ADD CLICK EVENT TO SVG MAP

    return ( 
        <>  
            <FixedControl
              opacity={started}
            />
            <CoverDiv
              started={started}
            >
              <MainDiv
                started={started}
              >
                <IntroContainer/>
                {
                  started &&
                  <>
                    <MainChartContainer/>
                    <Credit/>
                  </>
                }
              </MainDiv>
            </CoverDiv>
        </>
     );
}
 
export default ChartLayout;